import { IVehicleRead } from 'common/services/residents-service/residents.service.types';

export const formatVehicleLabel = (vehicle?: IVehicleRead | null) => {
  if (!vehicle) {
    return '';
  }

  return `${vehicle.make} ${vehicle.model} ${vehicle.licenseNumber} ${vehicle.licenseState}`;
};
